export enum Sender {
  me,
  ai,
}

export type ConversationItem = {
  sender: Sender
  message?: string
}
